import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useQuery } from "@apollo/client";
import { GET_TOWERS_QUERY } from "../../graphql/queries/towers";
import { GET_PACKAGES_QUERY } from "../../graphql/queries/packages";
import Loader from "../loader/loader";
import hasValue from "../../utils/hasValue";
import stringifyArray from "../../utils/arrayToString";
import DisplaySelect from "../display-select/display-select";
import MultiSelect from "../multi-select/multi-select";

const ClientsFilters = ({
  onFilter,
  onApplyFilters,
  setAppliedFilters,
  appliedFilters,
}) => {
  const { handleSubmit, control, setValue } = useForm({
    // defaultValues: {
    //   packages: appliedFilters.packages,
    //   towers: appliedFilters.towers,
    // },
  });

  const [towersData, setTowersData] = useState([]);
  const [packagesData, setPackagesData] = useState([]);

  const getTowersResponse = useQuery(GET_TOWERS_QUERY, {
    fetchPolicy: "network-only",
  });

  const getPackagesResponse = useQuery(GET_PACKAGES_QUERY, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (getTowersResponse?.data) {
      const data = getTowersResponse.data.towers.items.map((t) => ({
        value: t.zonkeId,
        label: t.zonkeId,
      }));
      setTowersData(data);
    }

    if (getPackagesResponse?.data) {
      const data = getPackagesResponse.data.packages.items.map((p) => ({
        value: p.id,
        label: p.name,
      }));
      setPackagesData(data);
    }
  }, [getTowersResponse, getPackagesResponse]);

  useEffect(() => {
    setValue("packages", appliedFilters.packages);
    setValue("towers", appliedFilters.towers);
  }, [appliedFilters, setValue]);

  if (getTowersResponse?.loading || getPackagesResponse?.loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (getTowersResponse?.error || getPackagesResponse?.error) {
    return (
      <div className="basic-modal">
        <div className="basic-modal__header">
          <h3>Error Loading Filters</h3>
        </div>
        <div className="basic-modal__body">
          <div
            className="input-container__error"
            style={{
              padding: "20px",
              backgroundColor: "#ffebee",
              border: "1px solid #ef5350",
              borderRadius: "4px",
              color: "#c62828",
            }}
          >
            {getTowersResponse?.error?.message ||
              getPackagesResponse?.error?.message ||
              "Failed to load filter options. Please try again."}
          </div>
          <div className="basic-modal__footer">
            <button onClick={onFilter} className="button button--secondary">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  const onSubmit = (data) => {
    setAppliedFilters({
      packages: data.packages,
      towers: data.towers,
    });
    onFilter();
  };

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Filter Clients</h3>
        {hasValue(appliedFilters) && (
          <div className="basic-modal__sub-header">
            Applied filters:
            <div className="basic-modal__sub-header-text--bold">
              {stringifyArray(appliedFilters.packages)},{" "}
              {stringifyArray(appliedFilters.towers)}
            </div>
          </div>
        )}
      </div>
      <div className="basic-modal__body">
        <form onSubmit={handleSubmit(onSubmit)} className="basic-modal__form">
          <div className="input-container">
            <DisplaySelect
              placeholder={"Packages"}
              name={"packages"}
              errors={{}}
            >
              <Controller
                name={"packages"}
                control={control}
                render={({ field }) => (
                  <MultiSelect
                    isDisabled={false}
                    field={field}
                    options={packagesData}
                  />
                )}
              />
            </DisplaySelect>
          </div>

          <div className="input-container">
            <DisplaySelect placeholder={"Tower"} name={"towers"} errors={{}}>
              <Controller
                name={"towers"}
                control={control}
                render={({ field }) => (
                  <MultiSelect
                    isDisabled={false}
                    field={field}
                    options={towersData}
                  />
                )}
              />
            </DisplaySelect>
          </div>

          <div className="basic-modal__footer">
            <button onClick={onFilter} className="button button--secondary">
              Cancel
            </button>
            <button type="submit" className="button button--primary">
              Apply
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClientsFilters;
